$(document).ready(function(){

	$('[data-component="new-bank-features"] .btn').on('mouseenter', function(){
		$('.btn i').attr('class', 'icon-arrow-right');
	}).on('mouseleave', function(){
		$('.btn i').attr('class', 'icon-arrow-right-white');
	})

});